import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { DASHBOARD, SPLASH } from "../../Auth/Routes";

const DefaultRoute = () => {
    const isUserLoggedIn = useSelector(
        (state) => state.login.isLoginApiSuccess
      );
  if (isUserLoggedIn) {
    return <Redirect to={DASHBOARD} />;
  }
  return <Redirect to={SPLASH} />;
};

export default DefaultRoute;
